export const labels = [
  {
    counter: "3 500 +",
    description: "bytů v naší správě",
  },
  {
    counter: "18 miliard",
    description: "hodnota portfolia",
  },
  {
    counter: "Největší",
    description: "služba svého druhu",
  },
  {
    counter: "Specialisté",
    description: "pro každou oblast",
  },
];

export const cards = [
  {
    counter: "01",
    title: "Váš nájemník jsme my",
    description:
      "Byt si od vás pronajmeme a dále ho podnajímáme prověřeným zájemcům. Řešíme inzerci, prohlídky i papírování.",
  },
  {
    counter: "02",
    title: "Nájem na den přesně",
    description:
      "Už žádné obavy, kdy a jestli vám přijde nájemné. Náš systém vám ho pošle na účet každý měsíc a na den přesně.",
  },
  {
    counter: "03",
    title: "Garantujeme stav bytu",
    description:
      "Jak jsme byt převzali, tak vám ho i vrátíme. Poradíme si i s případnými opravami a pojistnými událostmi.",
  },
];

type TItem = { label: string; value: string; id: string };
export const villages: Array<TItem> = [
  {
    id: "1",
    label: "Praha",
    value: "Praha",
  },
  {
    id: "2",
    label: "Brno",
    value: "Brno",
  },
  {
    id: "3",
    label: "Ostrava",
    value: "Ostrava",
  },
  {
    id: "4",
    label: "Plzeň",
    value: "Plzeň",
  },
  {
    id: "5",
    label: "Pardubice",
    value: "Pardubice",
  },
  {
    id: "6",
    label: "Olomouc",
    value: "Olomouc",
  },
  {
    id: "7",
    label: "České Budějovice",
    value: "České Budějovice",
  },
  {
    id: "8",
    label: "Hradec Králové",
    value: "Hradec Králové",
  },
];

export const dispositions: Array<TItem> = [
  {
    id: "1",
    label: "1+kk",
    value: "1+kk",
  },
  {
    id: "2",
    label: "1+1",
    value: "1+1",
  },
  {
    id: "3",
    label: "2+kk",
    value: "2+kk",
  },
  {
    id: "4",
    label: "2+1",
    value: "2+1",
  },
  {
    id: "5",
    label: "3+kk",
    value: "3+kk",
  },
  {
    id: "6",
    label: "3+1",
    value: "3+1",
  },
  {
    id: "7",
    label: "4+kk",
    value: "4+kk",
  },
  {
    id: "8",
    label: "4+1",
    value: "4+1",
  },
  {
    id: "9",
    label: "5+kk",
    value: "5+kk",
  },
  {
    id: "10",
    label: "5+1",
    value: "5+1",
  },
  {
    id: "11",
    label: "6+kk",
    value: "6+kk",
  },
  {
    id: "12",
    label: "6+1",
    value: "6+1",
  },
  {
    id: "13",
    label: "7+kk",
    value: "7+kk",
  },
  {
    id: "14",
    label: "7+1",
    value: "7+1",
  },
  {
    id: "15",
    label: "Atypický",
    value: "Atypický",
  },
  {
    id: "16",
    label: "Dům",
    value: "Dům",
  },
];

export const variants = [
  {
    title: "Profit",
    prefix: "Garant",
    description: "Potenciál nejvyššího výnosu",
    labels: ["88 % z tržního podnájemného", "1 Kč v případě neobsazeného bytu"],
  },
  {
    title: "Balanc",
    prefix: "Garant Plus",
    description: "Nejlepší poměr mezi ziskem a jistotou",
    labels: ["84 % z tržního podnájemného", "50 % v případě neobsazeného bytu"],
  },
  {
    title: "Jistota",
    prefix: "Garant Fix",
    description: "Plná garance – nižší výnos",
    labels: ["Fixní smluvené nájemné", "Plná garance při neobsazenosti"],
  },
];
